import { render, staticRenderFns } from "./pageSelect.vue?vue&type=template&id=6c90c103"
import script from "./pageSelect.vue?vue&type=script&lang=js"
export * from "./pageSelect.vue?vue&type=script&lang=js"
import style0 from "./pageSelect.vue?vue&type=style&index=0&id=6c90c103&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports